import { useState } from 'react';

export default function DrywallFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'How much does drywall installation cost in El Paso?',
      answer: 'Drywall installation in El Paso typically costs between $1.50 to $3.50 per square foot, including materials and labor. Factors affecting cost include project size, ceiling height, texture type, and complexity. A standard 12x12 room might cost $800-$1,500. Always get multiple quotes for accurate pricing.'
    },
    {
      question: 'How long does it take to complete a drywall project?',
      answer: 'Timeline varies by project size. A single room typically takes 2-3 days (hanging, taping, mudding, sanding, and finishing). Larger projects like whole-house drywall may take 1-2 weeks. Each coat of joint compound needs 24 hours to dry. Texture and painting add additional time.'
    },
    {
      question: 'What\'s the difference between drywall repair and replacement?',
      answer: 'Drywall repair involves patching holes, cracks, or damaged sections using joint compound and tape. It\'s suitable for minor damage under 6 inches. Replacement involves removing and installing new drywall panels, necessary for extensive water damage, large holes, or structural issues. Contractors assess which approach is best.'
    },
    {
      question: 'Do I need permits for drywall work in El Paso?',
      answer: 'Minor drywall repairs typically don\'t require permits. However, permits are usually needed for new construction, room additions, or structural modifications. Your contractor should handle permit applications and ensure work meets El Paso building codes. Always verify permit requirements with the city before starting major projects.'
    },
    {
      question: 'What types of drywall texture are popular in El Paso?',
      answer: 'Popular textures in El Paso include knockdown (most common), orange peel, smooth finish, and skip trowel. Knockdown offers a subtle texture that hides imperfections. Smooth finishes are modern and elegant but show every flaw. Your contractor can show samples and recommend the best texture for your space and style.'
    },
    {
      question: 'How do I prepare my home for drywall installation?',
      answer: 'Remove furniture and valuables from work areas. Cover remaining items with plastic sheeting. Ensure clear access to work zones. Turn off HVAC to prevent dust circulation. Discuss with your contractor about protecting floors and adjacent rooms. Professional contractors will handle most preparation and cleanup.'
    },
    {
      question: 'Can drywall be installed over existing walls?',
      answer: 'Yes, drywall can be installed over existing drywall or plaster in good condition. This is common in remodels to update texture or cover damage. However, it adds thickness to walls, affecting outlets, switches, and trim. Your contractor will assess if existing walls are suitable or if removal is better.'
    },
    {
      question: 'How do I maintain drywall in El Paso\'s dry climate?',
      answer: 'El Paso\'s dry climate can cause drywall cracks at seams. Maintain consistent indoor humidity (30-50%) using humidifiers. Repair small cracks promptly before they worsen. Use quality paint with primer for protection. Avoid hanging heavy items without proper anchors. Regular inspections help catch issues early.'
    },
    {
      question: 'What should I look for when hiring a drywall contractor?',
      answer: 'Verify licensing and insurance, check references and online reviews, review their portfolio of completed projects, get detailed written estimates from multiple contractors, ensure they offer warranties, confirm they handle permits and inspections, and assess their communication and professionalism. Never pay the full amount upfront.'
    },
    {
      question: 'How soon can I paint after drywall installation?',
      answer: 'Wait at least 24 hours after the final coat of joint compound is applied and sanded. In El Paso\'s dry climate, drying may be faster, but ensure compound is completely dry. Apply primer before paint for best results. Your contractor will advise on the optimal timeline for your specific project and conditions.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Get answers to common questions about drywall services in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:border-teal-500 transition-all">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">{faq.question}</h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-teal-600 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-sm text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
